import React from 'react';
import {useTranslations} from 'next-intl';
import {Content} from './Styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const Loading = ({}) => {
    const t = useTranslations('components.Loading');
    return (
        <Container maxWidth="sm">
            <Content>
                <Typography
                    variant="h2"
                    color="textSecondary"
                >
                    {t('title')}
                </Typography>
                <CircularProgress/>
            </Content>
        </Container>
    );
};

export default Loading;
